import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;

// 门户   政策公告
export const noticeInfo = {
  pageList: rootPath + "/web/pageList", // 政策公告 分页查询(get)
  noticeDetail: rootPath + "/web/getDetail", //政策公告详情
  fourData: rootPath + "/web/index/getCount",  // 首页 四个统计
}

// 获取banner
export const getBannerInfo = {
  pageList: rootPath + "/web/basicsImageInfo/pageList",   // 分页查询
}

// 获取网站设置
export const getWebInfo = {
  detail: rootPath + "/web/sysSite/detail",
}

// 获取网站设置
export const getWLinkPage = {
  pageList: rootPath + "/web/page",
}

// 获取基地信息
export const getCorpBaseInfo = {
  baseInfo: rootPath + "/web/webBaseEnterpriseStatisticsController/getWebBaseEnterprise2"
}